import React, { useState } from 'react';
import { IoMdArrowDropdown, IoMdArrowDropright } from 'react-icons/io';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearGlobalError } from "../../../app/globalSlice/globalSlice";

interface NavItemProps {
    route: string;
    icon: React.ReactElement;
    label: string;
    dropdownOptions?: NavDropdownOptions;
}

interface NavDropdownOptions {
    childDropdownItems: { label: string, route: string, hasPermission: boolean }[];
    isDropdownOpen: boolean;
    onDropdownToggle: () => void;
}

const NavItem: React.FC<NavItemProps> = ({
    route,
    icon,
    label,
    dropdownOptions
}) => {

    const isCollapsed = useSelector((state: any) => state.global.isCollapsed);
    const location = useLocation();
    const navigate = useNavigate();
    const splitLocation = location.pathname.split("/");
    const dispatch = useDispatch();

    const [isTooltipOpen, setIsTooltipOpen] = useState(false);

    const handleParentClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (dropdownOptions?.childDropdownItems) {
            e.preventDefault();
            if (dropdownOptions?.onDropdownToggle) {
                dropdownOptions?.onDropdownToggle();
            }
        }
    };

    const handleNavigation = (route: string) => {
        dispatch(clearGlobalError());
        navigate(route);
        setIsTooltipOpen(false); // Close the tooltip when a link is clicked
    };

    const handleMouseEnter = () => {
        if (isCollapsed) {
            setIsTooltipOpen(true);
        }
    };

    const handleMouseLeave = () => {
        if (isCollapsed) {
            setIsTooltipOpen(false);
        }
    };

    return (
        <li className={`relative group`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {dropdownOptions?.childDropdownItems ? (
                <button
                    onClick={handleParentClick}
                    className={`${splitLocation[1] === route.slice(1)} flex items-center px-4 py-2 text-text-0 hover:bg-highlight-6 group w-full ${isCollapsed ? "justify-center" : "justify-between"}`}>
                    <div className='flex items-center'>
                        {icon}
                        <span className={`font-normal ${isCollapsed ? 'hidden' : 'block'} ms-4 text-sm max-h-[300px] overflow-auto`}>{label}</span>
                        {isCollapsed && isTooltipOpen && (
                            <div className={"absolute left-[58px] top-1 bg-[transparent] shadow-[0,0,10px,rgba(0,0,0,10%)]"}>
                                <div
                                    className="  before:content-['']
                                    before:absolute
                                   before:content-['']
                                    before:absolute
                                    before:left-[-8px]
                                    before:top-2
                                    before:border-t-[5px] before:border-t-[transparent]
                                    before:border-b-[5px] before:border-b-[transparent]
                                    before:border-r-[8px] before:border-r-text-0
                                      text-left  bg-text-0 text-surface-0 w-44 rounded  shadow-[0_0_10px_rgba(0,0,0,0.2)]">
                                    <div className={'max-h-[300px] overflow-auto'}>
                                        {dropdownOptions?.childDropdownItems?.filter((el: any) => el.hasPermission).map((item, index) => (
                                            <Link
                                                key={index}
                                                to={item.route}
                                                onClick={() => handleNavigation(item.route)}
                                                className=' text-sm  hover:bg-highlight-3 block p-2'>
                                                {item.label}
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {!isCollapsed && (dropdownOptions?.isDropdownOpen ? <IoMdArrowDropdown /> : <IoMdArrowDropright />)}
                </button>
            ) : (
                <Link
                    to={route}
                    className={`${splitLocation[1] === route.slice(1) && "bg-highlight-6"} flex items-center px-4 py-2 text-text-0 hover:bg-highlight-6 group w-full ${isCollapsed ? "justify-center" : "justify-between"}`}
                    target="_self"
                    rel="noopener noreferrer"
                    title={label}
                    onClick={() => handleNavigation(route)}
                >

                    <div className='flex items-center'>
                        {icon}
                        {isCollapsed && isTooltipOpen && (
                            <div className={"absolute left-[58px] top-1 bg-[transparent] shadow-[0,0,10px,rgba(0,0,0,10%)]"}>
                                <div
                                    className="  before:content-['']
                                    before:absolute
                                   before:content-['']
                                    before:absolute
                                    before:left-[-8px]
                                    before:top-2
                                    before:border-t-[5px] before:border-t-[transparent]
                                    before:border-b-[5px] before:border-b-[transparent]
                                    before:border-r-[8px] before:border-r-text-1
                                      text-left  bg-text-0 text-surface-0 w-44 rounded  shadow-[0_0_10px_rgba(0,0,0,0.2)]">

                                    <Link to={route}
                                        onClick={() => handleNavigation(route)}
                                        className=' text-sm  hover:bg-highlight-3 block p-2'>
                                        {label}
                                    </Link>

                                </div>
                            </div>

                        )}
                        <span className={`font-normal ${isCollapsed ? 'hidden' : 'block'} ms-4 text-sm`}>{label}</span>
                    </div>
                </Link>
            )}

            {dropdownOptions?.isDropdownOpen && !isCollapsed && dropdownOptions?.childDropdownItems && (
                <ul className='pl-7 mb-0'>
                    {dropdownOptions?.childDropdownItems?.filter((el: any) => el.hasPermission).map((item, index) => (
                        <li key={index}
                            className='dropDownList relative text-sm font-normal cursor-pointer'>
                            <Link
                                to={item.route}
                                className={`${splitLocation[1] === item?.route?.slice(1) ? "text-[#80d5fa]" : ""} flex items-center py-2 text-sm`}
                                onClick={() => handleNavigation(item.route)}>
                                {item.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </li>
    );
};

export default NavItem;
